import { render, staticRenderFns } from "./participate-list.vue?vue&type=template&id=72d2f589&scoped=true&"
import script from "./participate-list.vue?vue&type=script&lang=js&"
export * from "./participate-list.vue?vue&type=script&lang=js&"
import style0 from "./participate-list.vue?vue&type=style&index=0&id=72d2f589&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d2f589",
  null
  
)

export default component.exports